import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page not found", noindex: true });
  return (
    <section className="max-w-3xl mx-auto px-4 py-32 text-center">
      <h1 className="text-4xl font-bold text-[#0B2A4A]">This page wandered off.</h1>
      <Link to="/" className="mt-6 inline-block text-[#F08A3C] font-semibold" data-testid="notfound-home-link">Back to home</Link>
    </section>
  );
}
